// Snow mode constants (matching backend ProjectConfiguration.SNOW_MODE_CHOICES)
export const SNOW_MODE_FIXED_PERCENTAGE = 0
export const SNOW_MODE_DYNAMIC = 1

export const SNOW_PROVIDER_CHOICES = [{ id: 0, name: 'Copernicus (C3S) ERA5-Land 2025' }] as const

// Countries where dynamic snow mode is supported (simply because of data not being put in S3)
export const DYNAMIC_SNOW_SUPPORTED_COUNTRIES = [
  'US',
  'GB',
  'AU',
  'NZ',
  // Europe West
  'AD',
  'AL',
  'AT',
  'BA',
  'BE',
  'CH',
  'CZ',
  'DE',
  'DK',
  'HR',
  'IE',
  'IS',
  'IT',
  'LI',
  'LU',
  'MC',
  'ME',
  'MK',
  'MT',
  'NL',
  'PT',
  'SI',
  'SM',
  'VA',
  'XK',
]

// Snow loss defaults by country/region
// Structure is extensible for adding more countries in the future
export const SNOW_LOSS_DEFAULTS: Record<string, Record<string, number>> = {
  US: {
    // 0%
    AL: 0,
    AZ: 0,
    AR: 0,
    CA: 0,
    FL: 0,
    GA: 0,
    HI: 0,
    LA: 0,
    MS: 0,
    NV: 0,
    NM: 0,
    NC: 0,
    OK: 0,
    OR: 0,
    SC: 0,
    TN: 0,
    TX: 0,
    VA: 0,
    WA: 0,
    // 2%
    DE: 2,
    KS: 2,
    KY: 2,
    MD: 2,
    MO: 2,
    NJ: 2,
    NY_CITY: 2,
    UT: 2,
    WV: 2,
    // 4%
    CO: 4,
    CT: 4,
    ID: 4,
    IL: 4,
    IN: 4,
    IA: 4,
    MA: 4,
    NE: 4,
    NH: 4,
    OH: 4,
    PA: 4,
    RI: 4,
    // 10%
    MN: 10,
    // 16%
    AK: 16,
  },
}

// Display name overrides for states/regions
// If a state has a custom display name, it will be shown instead of the state code
// Structure is extensible for adding more countries in the future
export const SNOW_LOSS_DISPLAY_NAMES: Record<string, Record<string, string>> = {
  US: {
    NY_CITY: 'NYC (City of New York Only)',
  },
}
